import React, { useState, useEffect } from "react";
import { queryContract } from "../../Components/functions/Contract";
import { getNibiruSDK, getContractAddresses } from "../../config/network";

const nibiru = getNibiruSDK();

// Helper function to get vault contract address based on network
const getVaultContractAddress = () => {
  const address = getContractAddresses().vault;
  if (!address) {
    throw new Error("Vault contract address not configured");
  }
  return address;
};
const EpochInfoDisplay = () => {
  const [epochInfo, setEpochInfo] = useState({
    currentEpoch: 0,
    timelockEpochs: 0,
    inActionWindow: true, // Hardcoded to true for now
    timeRemaining: ""
  });
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchEpochInfo = async () => {
      try {
        setLoading(true);
        
        // Get current epoch
        const currentEpoch = await queryContract(
          getVaultContractAddress(),
          { current_epoch: {} },
          nibiru.endptTm
        );
        
        // Get epoch timelock (wait periods)
        const timelock = await queryContract(
          getVaultContractAddress(),
          { withdraw_epochs_timelock: {} },
          nibiru.endptTm
        );
        
        setEpochInfo({
          currentEpoch: Number(currentEpoch),
          timelockEpochs: Number(timelock),
          inActionWindow: true, // Hardcoded to true for now
          timeRemaining: ""
        });
      } catch (error) {
        console.error("Error fetching epoch information:", error);
        setEpochInfo(prevState => ({
          ...prevState,
          currentEpoch: prevState.currentEpoch || 0,
          timelockEpochs: prevState.timelockEpochs || 0,
          inActionWindow: true // Keep it true even in case of error
        }));
      } finally {
        setLoading(false);
      }
    };
    
    fetchEpochInfo();
    const interval = setInterval(fetchEpochInfo, 600000); 
    
    return () => clearInterval(interval);
  }, []);
  
  if (loading) {
    return (
      <div className="ce-vault-panel p-4 mb-4 overflow-hidden">
        <div className="ce-eyebrow mb-3">Vault Epoch Information</div>
        <div className="flex justify-center py-4">
          <div className="ce-vault-spin" style={{ width: 24, height: 24 }} />
        </div>
      </div>
    );
  }
  
  return (
    <div className="ce-vault-panel p-4 mb-4 overflow-hidden">
      <div className="ce-eyebrow mb-4">Vault Epoch Information</div>

      {/* Four readouts, so four niches — the same recessed tile the vault's
          stat row uses, rather than four unmarked regions of the panel. */}
      <div className="grid grid-cols-2 gap-3 mb-4">
        <div className="ce-vault-well" style={{ padding: 12 }}>
          <div className="ce-eyebrow mb-1">Current Epoch</div>
          <div className="ce-figure" style={{ fontWeight: 600, fontSize: 16, color: "var(--ink)" }}>
            {epochInfo.currentEpoch}
          </div>
        </div>

        <div className="ce-vault-well" style={{ padding: 12 }}>
          <div className="ce-eyebrow mb-1">Withdrawal Timelock</div>
          <div className="ce-figure" style={{ fontWeight: 600, fontSize: 16, color: "var(--ink)" }}>
            {epochInfo.timelockEpochs} epochs
          </div>
        </div>

        <div className="ce-vault-well" style={{ padding: 12 }}>
          <div className="ce-eyebrow mb-1">Action Window</div>
          <div className="flex items-center gap-2">
            <span style={{ width: 7, height: 7, borderRadius: 999, background: "var(--up-2)", flex: "0 0 auto" }} />
            <span style={{ fontWeight: 600, fontSize: 16, color: "var(--ink)" }}>Open</span>
          </div>
        </div>

        <div className="ce-vault-well" style={{ padding: 12 }}>
          <div className="ce-eyebrow mb-1">Time Remaining</div>
          <div style={{ fontWeight: 600, fontSize: 16, color: "var(--ink)" }}>Waiting for next epoch</div>
        </div>
      </div>

      <ul className="space-y-1.5" style={{ color: "var(--ink-3)", fontSize: 12, lineHeight: 1.5 }}>
        <li>• Withdrawal requests can only be made during the first 48 hours of an epoch</li>
        <li>• Based on current vault status, requests will unlock after {epochInfo.timelockEpochs} epochs</li>
        <li>• Redemptions must be completed within 48 hours of the unlock epoch</li>
      </ul>
    </div>
  );
};

export default EpochInfoDisplay;